import mitt from "mitt";
import { onUnmounted } from "vue";

const emitter = mitt();

export function onBus(eventName, handler) {
  emitter.on(eventName, handler);
  onUnmounted(() => {
    emitter.off(eventName, handler);
  });
}

// Subscribe without the component-lifecycle auto-teardown. For subscribers that
// are NOT Vue components (e.g. the videojsPlayer class), where onUnmounted has
// no instance to bind to — they must pair this with busOff in their own dispose.
export function busOn(eventName, handler) {
  emitter.on(eventName, handler);
}

export function busOff(eventName, handler) {
  emitter.off(eventName, handler);
}

export const busEmit = emitter.emit;
